export default (fn, { timeout, interval, successCondition }) => {
  const endTime = Number(new Date()) + timeout
  let pollingTimeout = null

  const checkCondition = (resolve, reject) => {
    const ajax = fn()

    ajax.then(response => {
      if (successCondition(response)) {
        resolve(response)
      } else if (Number(new Date()) < endTime) {
        pollingTimeout = setTimeout(checkCondition, interval, resolve, reject)
      }
    })
  }

  return {
    start: () => new Promise(checkCondition),
    stop () {
      clearTimeout(pollingTimeout)
      pollingTimeout = null
    }
  }
}
